<template>
    <Form
        ref="form"
        :submit="submitPassword"
        class="w-full"
    >
        <div class="mb-4">
            <TextField
                name="password"
                label="new password"
                type="password"
                :validate="required"
                autocomplete="off"
            />
        </div>
        <MessageBlock
            v-if="error"
            type="warning"
            class="flex mb-4"
        >
            <Icon name="warning" />
            <div class="ml-2">
                {{ error }}
            </div>
        </MessageBlock>
        <div>
            <button
                :disabled="isPending"
                type="submit"
                class="btn-primary btn-solid btn-auth"
            >
                change
            </button>
        </div>
    </Form>
    <div class="mt-4 text-center">
        <button
            class="btn-link auth-btn-link"
            type="button"
            @click="backToSignIn"
        >
            back to sign in
        </button>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useAuthenticator } from '@aws-amplify/ui-vue';
import Form from '@/components/form/Form';
import TextField from '@/components/form/TextField';
import Icon from '@/components/ui/Icon.vue';
import MessageBlock from '@/components/ui/MessageBlock.vue';
import { required } from '@/components/form/validators';

const facade = useAuthenticator();

const isPending = computed(() => facade.isPending);

const error = computed(() => facade.error);

const submitPassword = async ({ password }) => {
    try {
        // aws-amplify triggers confirmSignIn({ challengeResponse: newPassword }) and transits to nextStep if the operation is successfully performed
        await facade.submitForm({ password });
    } catch (e) {
        console.error(e);
    }
};

const backToSignIn = () => facade.toSignIn();
</script>
